export default "__VITE_ASSET__C07iKjw2__"